module.exports = __webpack_public_path__ + "static/media/ils_covid_failed.872d6536.svg";